require('./externalTransferValuesStep3.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @helpers
const { getLastNChars } = require('utilities/stringHelper');

// @constants
const {
    EXTERNAL_TRANSFER_VALUES_ID,
} = require('constants/operationTypes');
const {
    SECOND_STEP,
    FIRST_STEP
} = require('constants/index');

const {
    CONFIRMATION_SCRIPT_AGREEMENT,
    CONFIRMATION_SCRIPT_GREETING,
    ConfirmationScript,
} = require('components/contactCenter/confirmScript/confirmationScript');

const PRINT_TITLE_VALUE = "transferExternalvaluesStep3-printTitleValue";

class ExternalTransferValuesStep3 extends React.Component {

    buildSummaryCC(){
        const { immExternalTransferValues } = this.props;

        const isinLabel = immExternalTransferValues.getIn(['steps', SECOND_STEP, 'isinLabel']);
        const noOfProducts = immExternalTransferValues.getIn(['steps', SECOND_STEP, 'noOfProducts']);
        const accountObject = immExternalTransferValues.getIn(['steps', FIRST_STEP, 'destinationAccountObject']);
        const accountNumber = getLastNChars(accountObject.get('associatedAccount'));
        const accountAlias = accountObject.get('associatedAccountAlias');
        const operativeName = formatText(PRINT_TITLE_VALUE);
        return (
            <div className="external-transfer-values-step3__summary">
                <ConfirmationScript
                    confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    operative={operativeName}
                />
                <div className="row">
                    <div className="col-xs-6">
                        <div className="print-label external-transfer-values-step3__summary-label">
                            <FormattedText
                                value="externalTransferValues-externalTransferValues_searchboxLabel"
                            />
                        </div>
                        <div className="external-transfer-values-step3__summary-value">
                            {isinLabel}
                        </div>
                    </div>
                    <div className="col-xs-6">
                        <div className="print-label external-transfer-values-step3__summary-label">
                            <FormattedText
                                value="externalTransferValues-externalTransferValues_noOfProducts"
                            />
                        </div>
                        <div className="external-transfer-values-step3__summary-value">
                            {noOfProducts}
                        </div>
                    </div>
                    <div className="col-xs-6">
                        <div className="print-label external-transfer-values-step3__summary-label">
                            <FormattedText
                                value="stocksContract-associatedAccount"
                            />
                        </div>
                        <div className="external-transfer-values-step3__summary-value">
                            <span>{accountAlias}</span>
                            &nbsp;
                            <span>{accountNumber}</span>
                        </div>
                    </div>
                </div>
                <ConfirmationScript
                    confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                />
            </div>
        );
    }

    render() {
        const operationParams = {
            //no parameter needed
        };
        const summaryContentCC = __CONTACT_CENTER__ && this.buildSummaryCC();

        return (
            <div className="external-transfer-values-step3">
                <h2 className="external-transfer-values-step3__title">
                    <FormattedText
                        value="externalTransferValues-externalTransferValues_step3Title"
                    />
                </h2>
                {summaryContentCC}
                <SignaturePattern
                    operationType={EXTERNAL_TRANSFER_VALUES_ID}
                    operationParams={operationParams}
                    printTitleValue={PRINT_TITLE_VALUE}
                />
            </div>
        );
    }
}

ExternalTransferValuesStep3.propTypes = {
    immExternalTransferValues: PropTypes.object,
};

module.exports = ExternalTransferValuesStep3;
